import 'scss/services/telrobot-capability-midware.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { layer } from 'js/libs/utils-layer'
import 'js/libs/jquery.validate/jquery.validate-config'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'
import { Base64 } from 'js-base64'

var type = 1
// 弹框效果
var alertTitle = [
  {
    title: '宽带到期提醒功能体验'
  },
  {
    title: '话费低余额提醒功能体验'
  },
  {
    title: '汽车4S店满意度回访功能体验'
  },
  {
    title: '会议邀约功能体验'
  }
]

var SubmitModel = {
  timer: null, // 定义一个定时器；
  geetestApi: function () {
    var that = this
    $.ajax({
      url: '/herapi/plug/geetestInit',
      type: 'get',
      dataType: 'json',
      success: function (data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captchaObj.onReady(function () {
          }).onSuccess(function () {
            that.result = captchaObj.getValidate()
            if (!that.result) {
              return alert('请完成验证')
            }
            // 获取验证码
            that.eventList.getCode()
          })
          $('#confirm').click(function () {
            $('#xfyeta-apply-form').validate().element($('#xfyetatel'))
            if ($('#error_tip').text() === '') {
              captchaObj.verify()
            }
          })
        })
      }
    })
  },
  getCodeInterval: function () {
    var that = this
    var $btn = $('#confirm')
    var $timeInterval = $('.time-interval')
    var time = 60// 定义时间变量。用于倒计时用
    $btn.hide() // 将按钮隐藏
    $timeInterval.show().text(time + '秒后重发')
    that.timer = setInterval(function () { // 开启定时器。函数内执行
      time--// 时间值自减
      if (time === 0) { // 判断,当时间值小于等于0的时候
        $btn.show()
        $timeInterval.hide()
        clearInterval(that.timer) // 清除定时器
        $timeInterval.text('')
      }
      $timeInterval.text(time + '秒后重发')// 点击发生后，文本内容变成之前定义好的时间值。
    }, 1000)
  },
  eventList: {
    getCode: function () {
      var that = SubmitModel // 调用后端接口，然后判断验证码是否获取成功，成功显示倒计时，不成功给个提示按扭不动
      var parames = {
        mobile: $('input[name="xfyetatel"]').val()
      }
      $.ajax({
        url: `/herapi/plug/mobilecode/get`,
        type: 'POST',
        dataType: 'json',
        data: parames,
        success: function (result) {
          if (result.flag) {
            that.getCodeInterval()
          } else {
            if (result.code !== 0) {
              let error = result.desc
              $('#error_tip').text(error)
            }
          }
        }
      })
    },
    ajaxSend: function (parames) {
      $.ajax({
        url: `/herapi/product/addLongTermTaskData`,
        type: 'POST',
        dataType: 'json',
        data: parames,
        success: function (result) {
          if (result.flag) {
            layer.close('.modalContainer')
            $('#call-pop-mask').css('display', 'block')
            $('.experienceDialog').css('display', 'block')
          } else {
            if (result.code !== 0) {
              let error = result.desc
              $('#error_tip').text(error)
            }
          }
        }
      })
    },
    submit: function () {
      var that = SubmitModel
      let parames = {}
      switch (type) {
        case 1:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? Base64.encode(that.result.geetest_seccode) : '',
            robotId: 20001571,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          }
          break
        case 2:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? Base64.encode(that.result.geetest_seccode) : '',
            robotId: 20001572,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          }
          break
        case 3:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? Base64.encode(that.result.geetest_seccode) : '',
            robotId: 20001570,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val(),
            name: $('input[name="username"]').val()
          }
          break
        case 4:
          parames = {
            geetest_challenge: that.result.geetest_challenge,
            geetest_validate: that.result.geetest_validate,
            geetest_seccode: that.result.geetest_seccode ? Base64.encode(that.result.geetest_seccode) : '',
            robotId: 20001723,
            mobile: $('input[name="xfyetatel"]').val(),
            code: $('input[name="yanzhengma"]').val()
          }
          break
      }
      that.eventList.ajaxSend(parames)
    }
  },
  addEvent: function () {
    var that = this
    $(document).on('click', '#taste_button', function () {
      // 获取当前选择的类型
      type = Number($('#dialect_select').val())
      $('#confirm').show()
      $('.time-interval').css('display', 'none')
      clearInterval(SubmitModel.timer) // 清除定时器
      layer.open('.modalContainer')
      $('.form-item-error').text('')
      $(':text').val('')
      $('.alert-title').html(alertTitle[type - 1].title)
    })
    $('.closeBtn').click(function () {
      $('#call-pop-mask').css('display', 'none')
      $('.experienceDialog').css('display', 'none')
      $('#confirm').show()
      $('.time-interval').css('display', 'inline-block')
      clearInterval(SubmitModel.timer) // 清除定时器
    })
    $('.icons-icons-close').click(function () {
      $('#confirm').show()
      $('.time-interval').css('display', 'none')
      clearInterval(SubmitModel.timer) // 清除定时器
    })
    // 验证表单事件
    $('#xfyeta-apply-form').validate({
      onfocusout: false,
      onkeyup: false,
      errorPlacement: function (error, element) {
        error.appendTo('.form-item-error')
      },
      showErrors: function (errorMap, errorList) {
        if (errorList.length !== 0) {
          $('#error_tip').empty().text(errorList[0].message)
        } else {
          $('#error_tip').empty()
        }
      },
      submitHandler: function () {
        that.eventList.submit()
      },
      rules: {
        xfyetatel: {
          required: true,
          isMobile: true
        },
        yanzhengma: {
          required: true
        }
      },
      messages: {
        xfyetatel: {
          required: '请输入手机号',
          isMobile: '手机号格式错误，请重新输入'
        },
        yanzhengma: {
          required: '请输入验证码'
        }
      }
    })
  },
  init: function () {
    var that = this
    that.addEvent()
    that.geetestApi()
  }
}

$(function () {
  serviceQA()
  serviceTopbar()
  SubmitModel.init()

  $('.apply-now').click(function () {
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(`${config.CONSOLE}workorder/commit?category=a83c70f3076d460d8e179d979f318fd2&tid=2d6058c9635e48719159144945b3d346&categoryName=A.I.客服平台能力中间件&tname=商务接洽&title=A.I.客服平台能力中间件 - 服务申请&id=xfyeta`)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/telrobot-capability-midware.js